import { render, staticRenderFns } from "./Vas10Question.vue?vue&type=template&id=aa7da8ec&scoped=true"
import script from "./Vas10Question.vue?vue&type=script&lang=js"
export * from "./Vas10Question.vue?vue&type=script&lang=js"
import style0 from "./Vas10Question.vue?vue&type=style&index=0&id=aa7da8ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7da8ec",
  null
  
)

export default component.exports